
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ldEQF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1df49a1a39b337bb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $1df49a1a39b337bb$export$2e2bcd8739ae039 = {
    'confluence-analytics-byline.abbreviated-user-views.message': "{count, plural, =0 {\u95B2\u89A7\u6570} other {{count}}}",
    'confluence-analytics-byline.page-viewers.message': "\u95B2\u89A7\u8005",
    'confluence-analytics-byline.user-views.message': "{count, plural, =0 {\u5206\u6790} other {{count} \u4EBA\u304C\u95B2\u89A7}}"
};

});


//# sourceMappingURL=ja.1ad9752d.js.map
